import { motion } from "framer-motion";

const ADVANTAGES = [
  "Une solide expérience dans la rénovation",
  "Un accompagnement personnalisé",
  "La coordination complète des travaux",
  "Des solutions adaptées à chaque logement",
  "Une attention particulière portée aux détails",
  "Une communication claire pendant le projet",
  "Un engagement envers la satisfaction du client",
];

export const Advantages = () => {
  return (
    <section id="pourquoi" data-testid="advantages-section" className="bg-mist">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:px-16 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mb-14 max-w-3xl"
        >
          <p className="mb-5 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.28em] text-brand">
            <span className="font-display text-sm tracking-normal text-slate-400">03</span>
            <span className="h-px w-8 bg-sun" aria-hidden="true" />
            Nos engagements
          </p>
          <h2
            data-testid="advantages-title"
            className="font-display text-3xl font-normal tracking-tight text-ink sm:text-4xl"
          >
            Pourquoi choisir Zion Solutions Suisse Sàrl&nbsp;?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-x-10 md:grid-cols-2 lg:grid-cols-3">
          {ADVANTAGES.map((advantage, i) => (
            <motion.div
              key={advantage}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`advantage-item-${i + 1}`}
              className="group flex items-baseline gap-5 border-t border-slate-200 py-7 transition-colors duration-300 hover:border-brand/50"
            >
              <span className="font-display text-sm font-medium text-brand">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="text-base font-medium leading-relaxed text-slate-700 transition-colors duration-300 group-hover:text-ink sm:text-lg">
                {advantage}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
